// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import campaignResultEntity from './entities/campaign-result.json';
import campaignResultMenu from '../pages/campaign-result/menu.json';
import campaignResultFullForm from '../pages/campaign-result/forms/full.json';
import campaignResultContextForm from '../pages/campaign-result/forms/context.json';
import campaignResultMiniForm from '../pages/campaign-result/forms/mini.json';
import campaignResultLookupForm from '../pages/campaign-result/forms/lookup.json';
import campaignResultTableView from '../pages/campaign-result/views/table.json';
import campaignResultCardsView from '../pages/campaign-result/views/cards.json';
import campaignResultDashboardView from '../pages/campaign-result/views/dashboard.json';

/** Тип запису «Результат кампанії» зі сторінками пакета: меню, форми та подання з pages/campaign-result/. */
export const campaignResultDefinition: IRecordTypeDefinition = {
  ...campaignResultEntity,
  views: assembleViewSet({
      table: campaignResultTableView,
      cards: campaignResultCardsView,
      dashboard: campaignResultDashboardView,
  }),
  form: campaignResultFullForm,
  forms: { full: campaignResultFullForm, context: campaignResultContextForm, mini: campaignResultMiniForm, lookup: campaignResultLookupForm },
  menu: campaignResultMenu,
} as IRecordTypeDefinition;
